// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedTeacherChangeReason {
  cancelledByStaff: {"enum_constant":"cancelledByStaff"};
  cancelledByTeacher: {"enum_constant":"cancelledByTeacher"};
  teacherAbsent: {"enum_constant":"teacherAbsent"};
}

export type TeacherChangeReasonId = keyof IParsedTeacherChangeReason;
export type TeacherChangeReasonData = IParsedTeacherChangeReason[TeacherChangeReasonId];
const data: TeacherChangeReasonData[] = [{"enum_constant":"cancelledByStaff"},{"enum_constant":"cancelledByTeacher"},{"enum_constant":"teacherAbsent"}];
export default data;
